/**
 * What the address holds of an order being taken: whose it is and where it
 * goes. The rest of the selection lives on the screen until the order is
 * made: it is a minute's work, and a link to it would be a link to nothing
 * once the catalog or the prices move.
 */
export interface NewOrderSearch {
  /** The client's user id. */
  client?: string;
  /** One of the client's addresses. */
  address?: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function parseNewOrderSearch(raw: Readonly<Record<string, unknown>>): NewOrderSearch {
  const search: NewOrderSearch = {};
  const client = raw["client"];
  if (typeof client !== "string" || !UUID.test(client)) return search;
  search.client = client;
  const address = raw["address"];
  // An address means nothing without the client it is one of.
  if (typeof address === "string" && UUID.test(address)) search.address = address;
  return search;
}
